// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__u9tw0","logo":"Logo_logo__ihN80"};